import React from "react";

type Props = {
  text?: string;
};

const Loading = ({ text = "Loading..." }: Props) => {
  return <div>{text}</div>;
};

export default Loading;
